import { NgModule } from "@angular/core";
import { datosGenerales } from "./datos-generales.component";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { DatosGeneralesService } from "./datos-generales.service";
import { CalendarModule } from 'primeng/primeng';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CabeceraModule } from "../../../components/common/cabecera/cabecera.module";
import { datosGeneralesIndividual } from "./datos-generales-individual.component";
import { datosGeneralesEmpresa } from "./datos-generales-empresa.component";
import { ConsultarUsuarioMasivos } from "../../../components/common/utils/consultarUsuarioMasivos";

@NgModule({
    declarations: [datosGenerales, datosGeneralesIndividual,datosGeneralesEmpresa],
    imports: [BrowserModule, HttpModule,
        FormsModule,
        CalendarModule,
        BrowserAnimationsModule,
        CabeceraModule],
    providers: [DatosGeneralesService,ConsultarUsuarioMasivos]
})

export class DatosGeneralesModule { }




// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/datosGenerales/datos-generales.module.ts